export const PARTY_TAB_SECTIONS_MAX_ITEMS = 3;

export const RISK_ANALYSIS_BE_FLOW_ID = '8b651328-5304-4980-bb23-177d6694a34b';
export const CUSTOMER_QUICKSCAN_BE_FLOW_ID =
  '21f46cd2-3e65-4d7a-93d5-99bcee38c840';
export const COMPANY_SCAN_BE_FLOW_ID = '83882ca1-af11-4776-a92a-793ebf149d42';
export const COMPANY_QUICKSCAN_BE_FLOW_ID =
  '37fc19f6-6c09-4d27-aca6-0378f4f97489';
export const RISK_ANALYSIS_NL_FLOW_ID = '4fccc81c-c38c-4a1f-abb3-c141edc77a2f';
export const CUSTOMER_QUICKSCAN_NL_FLOW_ID =
  '3e4ab13f-752c-43c5-8ff4-2946fb998785';
export const COMPANY_SCAN_NL_FLOW_ID = 'f2487edd-d796-4f8f-9a70-c61c96b8e01d';
export const COMPANY_QUICKSCAN_NL_FLOW_ID =
  '4030918c-df45-4920-adf5-d3217284bb1e';

const FULL_FLOW_IDS = [
  RISK_ANALYSIS_BE_FLOW_ID,
  COMPANY_SCAN_BE_FLOW_ID,
  RISK_ANALYSIS_NL_FLOW_ID,
  COMPANY_SCAN_NL_FLOW_ID,
];

export const QUICK_FLOW_IDS = [
  CUSTOMER_QUICKSCAN_BE_FLOW_ID,
  COMPANY_QUICKSCAN_BE_FLOW_ID,
  CUSTOMER_QUICKSCAN_NL_FLOW_ID,
  COMPANY_QUICKSCAN_NL_FLOW_ID,
];

export const ALL_FLOW_IDS = [...FULL_FLOW_IDS, ...QUICK_FLOW_IDS];
